import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Role } from '../services/role';
import { RoleService } from '../services/role.service';
import { RoleCreate, RoleDelete, RoleRefresh, RoleRefreshByID, RoleUpdate } from './role.action';
import { CatalogService } from '../../catalog-service';

import { catchError, EMPTY, tap } from 'rxjs';
import { Catalog } from 'src/app/common/enumerations/enumerations';

export class RoleStateModel {
  data: Role[] = [];
}

@State<RoleStateModel>({
  name: 'Roles',
  defaults: {
    data: [],
  },
})
@Injectable()
export class RoleState extends BaseState {
  constructor(
    protected override injector: Injector,
    private roleService: RoleService,
    private catalogService: CatalogService,
  ) {
    super(injector);
  }

  @Selector()
  static read(state: RoleStateModel) {
    return state.data;
  }

  @Action(RoleRefresh)
  refresh({ patchState }: StateContext<RoleStateModel>) {
    this.catalogService.GetJoinCreated(Catalog.Roles, true).toPromise().then((data) => {
      const roles = data?.roles ?? [];
      patchState({ data: roles });
    })
      .catch((error) => {
        console.error(error);
      });
  }

  @Action(RoleRefreshByID)
  refreshByID(ctx: StateContext<RoleStateModel>, { id }: RoleRefreshByID) {
    return this.roleService.ReadOne(id).pipe(
      tap((role) => {
        const state = ctx.getState();
        const index = state.data.findIndex((x) => x.id === id);

        const newData = [...state.data]; // ✅ new array reference

        // (Optional but recommended) ensure role is a new object reference too:
        const freshRole = { ...role };

        if (index >= 0) {
          if (role)
            newData[index] = freshRole; // ✅ replace element immutably
          else {
            newData.splice(index, 1); // ✅ remove element immutably
          }
        } else {
          newData.push(freshRole);
        }

        ctx.patchState({ data: newData });
      }),
      catchError((err) => {
        console.error(err);
        return EMPTY;
      }),
    );
  }

  @Action(RoleCreate)
  create(
    { getState, patchState }: StateContext<RoleStateModel>,
    { item }: RoleCreate,
  ) {
    patchState({
      data: [...getState().data, item],
    });
  }

  @Action(RoleUpdate)
  update(
    { getState, patchState }: StateContext<RoleStateModel>,
    { id, item }: RoleUpdate,
  ) {
    const state = getState();
    const index = state.data.findIndex((x) => x.id === id);
    const currentState = state.data;

    if (index >= 0) {
      currentState.splice(index, 1, item);
      patchState({ data: currentState });
    }
  }

  @Action(RoleDelete)
  delete(
    { getState, patchState }: StateContext<RoleStateModel>,
    { id }: RoleDelete,
  ) {
    patchState({
      data: getState().data.filter((x) => x.id !== id),
    });
  }
}
